<div class="input-form-box">
  <h1 class="label">{{ 'IMAGE' | translate }}</h1>
  
  <div class="input-box">
    <div class="file-upload-container" 
         [class.has-files]="selectedFilesCount > 0"
         [class.drag-over]="dragOver">
      
      <input
        type="file"
        class="file-input"
        (change)="onFileSelected($event)"
        [accept]="config.acceptTypes?.join(',')"
        [multiple]="config.multiple"
        #fileInput
      />
      
      <div class="upload-area" 
           (click)="fileInput.click()"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)"
           [class.drag-enabled]="config.dragAndDrop">
        
        <div class="upload-content">
          <div class="upload-icon">
            <div class="icon-wrapper">
              <img src="../../../../../assets/icon/inscription/upload.svg" alt="Upload" />
            </div>
          </div>
          
          <div class="upload-text">
            <div class="text-content">
              <span *ngIf="selectedFilesCount === 0" class="placeholder-text">
                {{ config.dragAndDrop ? 'DRAG_DROP_OR_CLICK' : 'CHOOSE_IMAGE' | translate }}
              </span>
              <span *ngIf="selectedFilesCount > 0" class="file-info">
                <span class="file-count">{{ selectedFilesCount }} {{ 'FILE_SELECTED' | translate }}</span>
                <span *ngIf="config.multiple && canAddMore" class="file-limit">
                  ({{ 'MAX_FILES' | translate }}: {{ config.maxFiles }})
                </span>
              </span>
            </div>
          </div>
        </div>
        
        <div class="upload-button">
          <span class="button-text">{{ 'BROWSE' | translate }}</span>
          <div class="button-icon">📁</div>
        </div>
      </div>
      
      <!-- Files list -->
      <div *ngIf="selectedFilesCount > 0" class="files-list">
        <div class="files-header">
          <span class="files-title">{{ 'SELECTED_FILES' | translate }}</span>
          <button *ngIf="config.multiple && selectedFilesCount > 1" 
                  type="button" 
                  class="clear-all-btn"
                  (click)="removeAllFiles()">
            {{ 'CLEAR_ALL' | translate }}
          </button>
        </div>
        
        <div class="files-container" [ngClass]="getPreviewClass()">
          <div *ngFor="let file of selectedFiles; let i = index" 
               class="file-item"
               [@fadeInOut]>
            
            <!-- File info -->
            <div class="file-info">
              <div class="file-name">{{ file.name }}</div>
              <div *ngIf="config.showFileSize" class="file-size">
                {{ getFileSize(file) }}
              </div>
            </div>
            
            <!-- Preview -->
            <div *ngIf="config.autoPreview && imagePreviews[i]" class="file-preview">
              <img [src]="imagePreviews[i]" [alt]="file.name" class="preview-image" />
            </div>
            
            <!-- Remove button -->
            <button *ngIf="config.showRemoveButton"
                    type="button" 
                    class="remove-file-btn"
                    (click)="removeFile(i)">
              ✕
            </button>
          </div>
        </div>
      </div>
      
      <!-- Drag overlay -->
      <div *ngIf="dragOver && config.dragAndDrop" class="drag-overlay">
        <div class="drag-message">
          <div class="drag-icon">📁</div>
          <span>{{ 'DROP_FILES_HERE' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Image is not required, so no error message needed -->
</div>
